<template>
  <ProbeConfiguration
    v-if="curTab === 'probe-configuration'"
    :rawDataModeSettings="[
      'header',
      'probe-name',
      'setting-mode',
      'unit-of-measurement',
      'frequencies',
      'ntc',
      'advanced-options'
    ]"
    :rawDataModeOptions="{
      disableMesUnitInput: true,
      disableABCFormula: true,
      disableNtcCompensation: true
    }"
    :customDataModeSettings="[
      'header',
      'probe-name',
      'setting-mode',
      'unit-of-measurement',
      'data-conversion-vw',
      'frequencies',
      'ntc',
      'advanced-options'
    ]"
    :customDataModeOptions="{
      disableNtcCompensation: false,
      disableMesUnitInput: false,
      disableABCFormula: false,
      rawUnit: 'Hz'
    }"
    :curTab="curTab"
    :sensor="sensor"
  />
  <AcquisitionParameter
    v-else-if="curTab === 'acquisition-parameters'"
    :curTab="curTab"
    :sensor="sensor"
    :settings="[
      'header',
      'cadence',
      'threshold-sampling',
      'zeroing',
    ]"
  />
  <Alarm v-else-if="curTab === 'alarm'" :curTab="curTab" :sensor="sensor" />
</template>

<script>
import ProbeConfiguration from "./ProbeConfiguration.vue";
import AcquisitionParameter from "./AcquisitionParameter.vue";
import Alarm from "./Alarm.vue";
export default {
  name: "typo-vibrating-wire-config",
  components: { ProbeConfiguration, AcquisitionParameter, Alarm },
  props: {
    curTab: null,
    sensor: null
  }
};
</script>

<style scoped></style>
